module.exports = __webpack_public_path__ + "static/media/be.9371bdba.webp";